module.exports = __webpack_public_path__ + "img/slings.e958970f.jpg";